import {Service, signal} from "@angular/core";
import type {DateTime} from "luxon";
import type {Nullable} from "../helpers/TypeHelpers";
import type {Existing} from "../models/base/IdentifiableModel";
import type {IdOnlyCustomerLocation} from "../models/customers/CustomerLocation";
import type {IdOnlyEquipmentInspectionType} from "../models/customers/equipment/EquipmentInspectionType";

@Service()
export class VisitCreationData {
  private readonly _customerLocation = signal<Nullable<Readonly<Existing<IdOnlyCustomerLocation>>>>(null);
  private readonly _startDate = signal<Nullable<DateTime<true>>>(null);
  private readonly _equipmentInspectionTypes = signal<readonly Readonly<IdOnlyEquipmentInspectionType>[]>([]);

  public get customerLocation(): Nullable<Readonly<Existing<IdOnlyCustomerLocation>>> {
    return this._customerLocation();
  }

  public set customerLocation(customerLocation: Nullable<Readonly<Existing<IdOnlyCustomerLocation>>>) {
    this._customerLocation.set(customerLocation);
  }

  public get startDate(): Nullable<DateTime<true>> {
    return this._startDate();
  }

  public set startDate(startDate: Nullable<DateTime<true>>) {
    this._startDate.set(startDate);
  }

  public get equipmentInspectionTypes(): readonly Readonly<IdOnlyEquipmentInspectionType>[] {
    return this._equipmentInspectionTypes();
  }

  public set equipmentInspectionTypes(equipmentInspectionTypes: readonly Readonly<IdOnlyEquipmentInspectionType>[]) {
    this._equipmentInspectionTypes.set(equipmentInspectionTypes);
  }

  public clear(): void {
    this._customerLocation.set(null);
    this._startDate.set(null);
    this._equipmentInspectionTypes.set([]);
  }
}
